/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Entity_CreditInputs */

const cs_enum_entity_credit = /** @type {(inputs: Enum_Entity_CreditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kredit`)
};

const en_enum_entity_credit = /** @type {(inputs: Enum_Entity_CreditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credit`)
};

/**
* | output |
* | --- |
* | "Credit" |
*
* @param {Enum_Entity_CreditInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_entity_credit = /** @type {((inputs?: Enum_Entity_CreditInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Entity_CreditInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_entity_credit(inputs)
	return cs_enum_entity_credit(inputs)
});